import React from 'react';
import DialogComponent from '../widgets/dialog/DialogComponent';

export default class AddDeviceModeDialog extends DialogComponent {

  state = {
    value: ''
  }

  render() {
    return (
      <>
        <input
          type="text"
          className="form-control text-center ltr"
          placeholder="سریال سنسور مورد نظر را وارد کنید"
          onChange={this.onKeyChange} />
        <div className="row">
          <div className="col-2 mr-auto">
            <button
              className="btn btn-block btn-primary mt-2"
              onClick={() => { this.resolve(this.state.value) }}>افزودن</button>
          </div>
        </div>
      </>
    );
  }

  private onKeyChange = (e: any) => {
    this.setState({ value: e.target.value });
  }

}
